export class SearchCriteria {
  searchText: string = '';
  page: number = 0;
  size: number = 10;
  sortField: string = '';
  sort: string = 'asc';
  companyList:any=[];

  constructor(searchText: string = '', page: number = 0, size: number = 10, sortField: string = '', sort: string = 'asc',companyList:any=[]) {
      this.searchText = searchText;
      this.page = page;
      this.size = size;
      this.sort = sort;
      this.sortField = sortField;
      this.companyList=companyList;
  }

  setSorting( sortField: string = '', sort: string = 'asc') {
    this.sortField=sortField;
    this.sort=sort;
  }
}